import { service } from '@/request/server'

// 病症列表
export const illnessList = (params) => (
  service({
    url: '/Illness/illnessList',
    method: 'GET',
    params
  })
)

// 病症详情
export const illnessDetail = (params) => (
  service({
    url: '/Illness/illnessDetail',
    method: 'GET',
    params
  })
)

// 添加/编辑病症
export const saveIllness = (params) => (
  service({
    url: '/Illness/saveIllness',
    method: 'POST',
    data: params
  })
)

// 设置常见病症
export const setIsCommon = (params) => (
  service({
    url: '/Illness/setIsCommon',
    method: 'POST',
    data: params
  })
)

// 病症分类列表
export const categoryList = (params) => (
  service({
    url: '/Illness_category/categoryList',
    method: 'POST',
    data: params
  })
)

// 病症分类详情
export const categoryDetail = (params) => (
  service({
    url: '/Illness_category/categoryDetail',
    method: 'POST',
    data: params
  })
)

// 添加/编辑病症分类
export const saveCategory = (params) => (
  service({
    url: '/Illness_category/saveCategory',
    method: 'POST',
    data: params
  })
)

// 删除病症
export const delIllness = (params) => (
  service({
    url: '/Illness/delIllness',
    method: 'POST',
    data: params
  })
)

// 删除病症分类
export const delIllnessCategory = (params) => (
  service({
    url: '/Illness_category/delIllnessCategory',
    method: 'POST',
    data: params
  })
)